// extracted by mini-css-extract-plugin
export default {"Theme":"channel_Theme__7LLJB","Section":"channel_Section__shTJC"};